import './styles/fonts/montserrat-font.scss';


import './index.scss'; //Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.


require('gsap');
require('./vendor/gsap/plugins/MorphSVGPlugin');
require('./vendor/gsap/plugins/DrawSVGPlugin');
require('smoothscroll-polyfill').polyfill();

var ScrollMagic = require('ScrollMagic');
require('animation.gsap');
require('debug.addIndicators');


import initBGSections from './script/sections';

import {getViewportSize} from './script/utils/responsive';

import initializeSVGBusinessDesignTechnology from './script/svganimations/business-design-technology';
import initializeSVGClients from './script/svganimations/clients';



var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
  e = e || window.event;
  if (e.preventDefault)
    e.preventDefault();
  e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

function disableScroll() {
  scroll(0,0);
  if (window.addEventListener) // older FF
    window.addEventListener('DOMMouseScroll', preventDefault, false);
  window.onwheel = preventDefault; // modern standard
  window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
  window.ontouchmove  = preventDefault; // mobile
  document.onkeydown  = preventDefaultForScrollKeys;
}

function enableScroll() {
  if (window.removeEventListener)
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
  window.onmousewheel = document.onmousewheel = null;
  window.onwheel = null;
  window.ontouchmove = null;
  document.onkeydown = null;
}


//init Section Animations
initBGSections('section__bg');

const controller = new ScrollMagic.Controller();



const logoAnimation = () => {

  const RaysLabLogo = document.getElementById('RaysLabLogo');
  const logoHeight = RaysLabLogo.getBoundingClientRect().height;

  document.getElementById('logotransform').style.paddingTop = (logoHeight + 50) + 'px';
  disableScroll();



  new TimelineMax({stagger: 2, tweens: [
    TweenMax.fromTo('#gsap_RaysLabLogo', .5, {opacity: 0, y: 0}, {
      opacity: 1,
      y: -logoHeight / 2,
      delay: .5,
      ease: Circ.easeOut
    }),
    TweenMax.fromTo([RaysLabLogo, '.section--intro .section__bg'], 2, {opacity: 1}, {
      opacity: 0,
      onComplete: function (e) {
        RaysLabLogo.style.display = 'none';
        document.getElementById('gsap_RaysLabLogo_to_AWARE').style.position = 'static';

      }
    }),
    TweenMax.fromTo(['#gsap_RaysLabLogo_to_AWARE'], 1, {opacity: 0}, {
      opacity: 1,
    }),
    TweenMax.to(['#gsap_RaysLabLogo_to_AWARE'], 1, {opacity: 0, onComplete:
    function () {
      document.getElementById('gsap_RaysLabLogo_to_AWARE').style.display = 'none';
      document.getElementById('AWARELogo').style.position = 'static';
    }
  }),
    TweenMax.fromTo(['#AWARELogo'], 1, {opacity: 0}, {
      opacity: 1,
      onComplete: function () {
        // Scroll to a certain element
        document.querySelector('#logotransform').scrollIntoView({
          behavior: 'smooth'
        });
        setTimeout(function () {
          enableScroll();
        }, 500);
      }
    })

  ]});




  const gsap_RaysLabLogo = document.getElementById('gsap_RaysLabLogo');

  const logoTweenline = new TimelineMax();
  logoTweenline.add(
    [TweenMax.to('#gsap_RaysLabLogo', .5, {scale: 0.7})
    ]);

  new ScrollMagic.Scene(
    {triggerElement: "#logotransform", duration: logoHeight, triggerHook: 'onEnter', offset: logoHeight})
    .setTween(logoTweenline)
    .addTo(controller);


  const scene = new ScrollMagic.Scene(
    {triggerElement: "#gsap_RaysLabLogo", duration: getViewportSize().h + logoHeight})
    .setPin("#gsap_RaysLabLogo")
    .addTo(controller);


};

const InformationEcologyAnimation = () => {
  "use strict";

  new ScrollMagic.Scene(
    {triggerElement: '#InformationEcology', offset: 20}
  ).setTween(new TimelineMax().add([
      TweenMax.from("#InformationEcologyContent", 1, {x: -80, y: -45}),
      TweenMax.from("#InformationEcologyContext", 1, {x: 0, y: 0}),
      TweenMax.from("#InformationEcologyUser", 1, {x: 80, y: -45})
    ]
    ).add(TweenMax.staggerFromTo('#InformationEcology .text', .5, {opacity: 0}, {opacity: 1}, .25))
    .add(TweenMax.from('#InformationEcology .InformationEcologyOptimal', .5, {opacity: 0}))
    )
    .addTo(controller);

  new ScrollMagic.Scene(
    {triggerElement: '#InformationEcology', offset: 0}
  ).setTween(new TimelineMax().add([
      TweenMax.from("#InformationEcologyContent", 1, {drawSVG: 0, delay: 0.5}),
      TweenMax.from("#InformationEcologyContext", 1, {drawSVG: 0}),
      TweenMax.from("#InformationEcologyUser", 1, {drawSVG: 0, delay: 0.75}),
    ]
  )).addTo(controller);





};



document.addEventListener("DOMContentLoaded", () => {
  "use strict";

  setTimeout(()=> {
    logoAnimation();
  }, 500);

  InformationEcologyAnimation();





  initializeSVGBusinessDesignTechnology();
  initializeSVGClients();





});



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/